import { render, staticRenderFns } from "./holy-grail.template.html?vue&type=template&id=5107af09&scoped=true&"
var script = {}
import style0 from "./holy-grail-grid.template.vue?vue&type=style&index=0&id=5107af09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5107af09",
  null
  
)

export default component.exports